import { FC } from "react";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import "./custom.scss";
import { MONTHS } from "lib/constants";
import { DEFAULT_BUBBLE_VALUE } from "lib/constants/default-values";
import { calculateMonthlyData } from "lib/utils/monthly-data-util";

interface ClinicMonthlyDataChartProps {
  data: BookingEntry[];
  width?: string | number;
  height?: string | number;
  className?: string;
}

const ClinicMonthlyDataChart: FC<ClinicMonthlyDataChartProps> = ({
  data,
  width = "100%",
  height = "100%",
  className,
}) => {
  const { monthlyData: monthlyBookings, yAxisMax } = calculateMonthlyData(
    data,
    "bookings"
  );

  const series = [
    {
      name: "Appointments",
      data: monthlyBookings.map((bookingCount, index) => ({
        x: index + 1,
        y: bookingCount,
        z: Math.max(bookingCount, DEFAULT_BUBBLE_VALUE),
        meta: `Appointments: ${bookingCount}`,
      })),
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: "bubble",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: ["#00E396"],
    xaxis: {
      min: 0.5,
      max: 12.5,
      tickAmount: 12,
      labels: {
        style: { fontSize: "14px" },
        formatter: (val) => MONTHS[Math.round(Number(val) - 1)] || "",
      },
      title: { text: "Months" },
    },
    yaxis: {
      title: { text: "Count" },
      max: yAxisMax,
    },
    fill: {
      opacity: 0.9,
    },
    tooltip: {
      custom: ({ seriesIndex, dataPointIndex, w }) => {
        const point =
          w.globals.initialSeries?.[seriesIndex]?.data?.[dataPointIndex];
        return `<div class="p-2">${point?.meta || "No Data"}</div>`;
      },
    },
    dataLabels: { enabled: false },
    legend: { show: true },
    grid: { show: false },
  };

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="bubble"
      width={width}
      height={height}
      className={className}
    />
  );
};

export default ClinicMonthlyDataChart;
